import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseSwitcher from './HseSwitcher.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseSwitcher;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"hse-Switcher",class:{
    'hse-Switcher_checked': _vm.checked,
    'hse-Switcher_inactive': _vm.inactive
  }},[_c('input',_vm._g(_vm._b({staticClass:"hse-Switcher__input",class:_vm.classes.input,attrs:{"disabled":_vm.inactive,"type":"checkbox"},domProps:{"checked":_vm.checked}},'input',_vm.$attrs,false),_vm.listeners)),_vm._v(" "),_c('HseSwitcherIcon',_vm._b({class:_vm.classes.icon,attrs:{"focused":_vm.focused}},'HseSwitcherIcon',_vm.$props,false)),_vm._v(" "),(_vm.label || _vm.$slots.default)?_c('div',{staticClass:"hse-Switcher__label",class:_vm.classes.label},[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])],2):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
